import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POIConferenceRoomsFields from "@/components/POI/POIConferenceRoomsFields/POIConferenceRoomsFields.vue";
export default {
  name: "POIConferenceRooms",
  components: {
    POIConferenceRoomsFields,
    POIStep
  },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    saveHelper() {
      this.$emit("save", false);
    }
  }
};
